import React, { useState, useEffect } from 'react';
import { Monitor } from 'lucide-react';

interface MobileWarningProps {
  language: string;
}

const MobileWarning: React.FC<MobileWarningProps> = ({ language }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [timeLeft, setTimeLeft] = useState(5);
  const [hasStarted, setHasStarted] = useState(false);

  const translations = {
    en: {
      message: "To ensure optimal user experience, we recommend accessing Tai Nguyen's portfolio website on a desktop computer",
    },
    vi: {
      message: "Để đảm bảo trải nghiệm người dùng tối ưu, chúng mình khuyến nghị bạn truy cập website portfolio của Tai Nguyen trên máy tính",
    }
  };

  const t = translations[language as keyof typeof translations];

  useEffect(() => {
    const checkDevice = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile && !hasStarted) {
        setHasStarted(true);
        // Bắt đầu với trạng thái ẩn, đợi 20s sau mới hiện
        setIsVisible(false);
      }
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, [hasStarted]);

  useEffect(() => {
    if (!isMobile) return;

    let timer: NodeJS.Timeout;

    if (isVisible) {
      if (timeLeft > 0) {
        timer = setTimeout(() => {
          setTimeLeft(prev => prev - 1);
        }, 1000);
      } else {
        setIsVisible(false);
      }
    } else {
      timer = setTimeout(() => {
        setIsVisible(true);
        setTimeLeft(5);
      }, 20000); // 20s delay
    }

    return () => clearTimeout(timer);
  }, [isVisible, isMobile, timeLeft]);

  if (!isVisible || !isMobile) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] p-4 bg-white/95 dark:bg-gray-800/95 backdrop-blur-sm shadow-lg border-b border-gray-200 dark:border-gray-700 transition-all duration-300">
      <div className="flex items-start gap-3 max-w-5xl mx-auto">
        <div className="flex-shrink-0 p-2 bg-blue-100 dark:bg-blue-900 rounded-full text-blue-600 dark:text-blue-400">
          <Monitor size={20} />
        </div>
        <p className="flex-grow text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
          {t.message}{' '}
          <span className="text-xs text-gray-400 dark:text-gray-500 italic whitespace-nowrap">
            (Auto-close in {timeLeft}s)
          </span>
        </p>
      </div>
    </div>
  );
};

export default MobileWarning;